class SwatchDrawer extends HTMLElement {
  constructor() {
    super();

    document.body.appendChild(this);
    this.variantSelect = document.querySelector("variant-selects");

    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelector("#SwatchDrawer-Overlay").addEventListener(
      "click",
      this.close.bind(this)
    );
    this.setHeaderCartIconAccessibility();
    /* option changed */
    var options = this.querySelectorAll(".swatch-input__label");
    options.forEach((opt) => {
      if (!opt.getAttribute("data-event")) {
        opt.addEventListener("click", (event) => {
          let targetElement = document.getElementById(
            this.getAttribute("data-target-id")
          );
          if (targetElement) {
            targetElement.value = opt.getAttribute("data-value") || opt.title;
            const changeEvent = new Event("change", {
              bubbles: true, // Allows the event to bubble up to parent elements
              cancelable: true,
            });
            /*触发variant更改事件, 重新获取html*/
            if(!this.blockRefresh)
              targetElement.dispatchEvent(changeEvent);
          }

          this.close();
        });
        opt.setAttribute("data-event", true);
      }
    });
  }

  setOpenEvent() {
    let openElement = document.getElementById(this.openId);

    if (openElement)
      openElement.addEventListener("click", (event) => {
        event.preventDefault();
        this.open(openElement);
      });
    else {
      console.log(
        "Can't find the element for open the drawer with id " + openId
      );
    }
  }

  setHeaderCartIconAccessibility() {
    let optionName = this.getAttribute("data-option");
    this.blockRefresh = this.getAttribute('block-refresh');
    this.openId = `${optionName}_drawer_selected_text`;
    this.setAttribute("data-open-id", this.openId);
    this.setOpenEvent();
  }

  open(triggeredBy) {
    if (
      triggeredBy.getAttribute("data-option") !=
      this.getAttribute("data-option")
    )
      return;

    if (triggeredBy) this.setActiveElement(triggeredBy);

    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add("animate", "active");
    });

    document.body.classList.add("overflow-hidden");
  }

  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}
if (!customElements.get("swatch-drawer"))
  customElements.define("swatch-drawer", SwatchDrawer);
